import { type Rotina, type RotinaInput, rotinaSchema } from '@acme/core'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { rotinas } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { RotinaForm } from '../atoms/RotinaForm'

const ROTINA_NOVA: Omit<RotinaInput, 'empresaId'> = {
    nome: '',
    notificarFalha: false,
    continuarComFalha: false,
    condicoes: [
        {
            condicaoId: 'falta',
            ocorre: true,
            conector: 'E',
            parametros: { tipo: 'integral', comparacao: 'acima' },
        },
    ],
    acoes: [],
}

export default function AdicionarRotina() {
    const empresaId = useStore(state => state.companyId)
    const { mutateAsync, isLoading } = rotinas.mutations.useCreate({
        invalidateQuery: true,
    })

    const handleSubmit = (rotina: Rotina) =>
        mutateAsync(rotina, {
            onSuccess: () => {
                toast.success('Rotina adicionada com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="3xl"
            shouldTransformarValores={false}
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={rotinaSchema}
            defaultValues={{ ...ROTINA_NOVA, empresaId }}
            open={hasPermission(['create', 'Rotinas'])}
        >
            <Dialog.Title>Nova rotina</Dialog.Title>
            <Dialog.Content>
                <RotinaForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
